import React , {useEffect , useState} from 'react';
import {Button ,   Modal , ModalBody , ModalHeader } from 'reactstrap';

import {useExtSubmission} from 'api';
import {areaData} from "constants/lookupData";
import {formatDate } from "../../script/commFunc";
import moment from "moment/moment";
import CpmCommCodeRadio from "./CpmCommCodeRadio";


const tgCatgList = [
    {type : "TOT", lable : "전체" }
    ,{type : "M_TOT", lable : "남자" }
    ,{type : "F_TOT", lable : "여자" }
]

/**
 *
 * User : YUJIN
 * Date : 2023.11.22
 * @ file : Components/Common/CpmcommPFindTarget.js
 * @ Desc : 타겟  검색 공통 팝업 Component
 * @param {string} params  외부에서 입력한 값
 * @param {boolean} modalIsOpen 모달 렌더링 여부
 * @param {React.SetStateAction | Function} handleModal 모달 상태 제어 함수
 * @param {React.SetStateAction | Function} onChangeParams 외부 컴포넌트 params 세터 함수
 */
const CpmcommPFindTarget = ( {
                                 params ,
                                 setParam  ,
                                 modalIsOpen ,
                                 handleModal ,
                                 onChangeParams
                             } ) => {
    const extSubmission = useExtSubmission();
    const [tgDataList, setTgDataList] = useState([]); //타겟 카테고리
    const [tgAreaCd, setTgAreaCd] = useState(params); //타겟 지역

    //지역 선택
    const areaOpt  =  {
        id: "tgAreaCd",
        cmCodes: areaData ,
        params: tgAreaCd,
        setParams: setTgAreaCd,
        isDisabled : false,
    }

    const  getTargetList = () => {
        const dtParams = {
            stDt: formatDate(moment( new Date() ), "yyyyMMDD"),
            edDt:formatDate(moment( new Date() ), "yyyyMMDD"),
            sql :"common.selectCprpTgGroupList"
        }
        //캠페인 선호타겟 조회
        extSubmission(
            "/cpm/com/commCode/commonSelect.do",
            dtParams,
            (e, data) => {
                setTgDataList(
                    data.result?.list.map((el) => {
                            let _tg = {
                                ...el ,
                                chkYn : (( params?.tgId && ( params?.tgId?.filter( ( k ) => el.tgId === k.tgId ) )?.length > 0 ) ? "Y" : "N")||"N"
                            };
                            if(el.repColNm.indexOf("_TOT") > 0  || el.repColNm === "PUT"){
                                _tg.ord  = 1 ;
                                _tg.type  =  "TOT" ;
                            }else if( el.repColNm.indexOf("M") === 0 ){
                                _tg.ord  = 2 ;
                                _tg.type  =  "M_TOT" ;
                            }else if( el.repColNm.indexOf("F") === 0 ){
                                _tg.ord  = 3 ;
                                _tg.type  =  "F_TOT" ;
                            }
                            _tg.ord = Number( _tg.ord + ""+  _tg.tgId ) ;
                            return _tg;
                        }
                    ).sort((a, b) => a.ord-b.ord  )
                )

                //전체영역 체크여부
                tgDataList.filter((tg) => tg.chkYn === "Y" && tg.type  ===  "TOT" )?.forEach((el)=>{
                    el.checked  = true ;
                    checkAllTarget(el)   ;
                })

            },
            'N'
        );
    }


    // 확인 버튼 클릭 시
    const onClick_BtnSelect = () => {
        try{
            //지역
            const  areaObj = document.querySelector( "#commPFindTarget input[name='radio_tgAreaCd']:checked")  ;
            const  areaNm = document.querySelector( "label[for='"+areaObj?.id+"']")?.innerHTML  ;

            const  chkList =  tgDataList.filter((tg) => tg.chkYn === "Y")  ;
            if(chkList?.length  === 0  ){
                alert("타겟을 선택하십시요.")
                return false ;
            }
            const  tgStr =  tgDataList.filter((tg) => tg.chkYn === "Y")
                                      .reduce((acc, cur, indx ) =>  acc + ((indx >0 ) ? "," : "" )+ cur.tgNm, areaNm+"-")  ;
            setParam({tgId : chkList , tgStr : tgStr , tgAreaCd : areaObj.value }) ;
        }catch (e) {
        }
        handleModal(false);
    }



    //타겟 선택시
    const onChangeCheckTarget = (e) => {
        const obj = e?.target   ;
        const  repC = obj.getAttribute('data-repcolnm')   ;
        const  _type = obj.getAttribute('data-type')   ;
        if(_type === "TOT"){
            const item = {
                repColNm : repC
                , checked : obj.checked
            }
            checkAllTarget(item)   ;
        }
        setTgDataList( tgDataList.map((tg) => {
                if(tg.tgId ===  obj.value ){
                    tg.chkYn = (obj.checked ) ? "Y" : "N"
                }
                return tg   ;
            })
        );
    };

    /**
     * 전체 영역 선택 되었을때
     * @param obj 선택된 item
     */
    const checkAllTarget = ( obj ) =>{
        if(obj.repColNm.indexOf("TOT") > 0  ){
            const  qryStr1 =   "input[type='checkbox'][data-repcolnm$='TOT']:not([data-repColNm='"+obj.repColNm+"'])" ;
            document.querySelectorAll( qryStr1 ).forEach((chk) => {
                chk.checked = false   ;
                chk.disabled = obj.checked  ;
                try{
                    if( obj.checked){
                        setTgDataList(tgDataList.map((tg) => {
                            if(tg.tgId === chk.value ){
                                tg.chkYn = "N" ;
                            }
                            return  tg ;
                        })) ;
                    }
                }catch (e) {
                }
            });
        }
        const  qryStr =  (obj.repColNm  === "PUT") ? "input[type='checkbox'][id^='ch-tg-']:not([data-repColNm='PUT'])" : "input[type='checkbox'][id^='ch-tg-']."+obj.repColNm ;
        document.querySelectorAll( qryStr ).forEach((chk) => {
            chk.checked = false   ;
            chk.disabled = obj.checked  ;
            try{
                if( obj.checked){
                    setTgDataList(tgDataList.map((tg) => {
                        if(tg.tgId === chk.value ){
                            tg.chkYn = "N" ;
                        }
                        return  tg ;
                    })) ;
                }
            }catch (e) {
            }
        });
    }

    useEffect(() => {
        if ( modalIsOpen ) {
            getTargetList()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalIsOpen] )
    
    return (
        <>
            <Modal size='lg' isOpen={modalIsOpen} backdrop={'static'} id="commPFindTarget" centered toggle={() => { handleModal(); }} >
                <ModalHeader className="modal-title" id="commPFindTarget-title" toggle={handleModal}>
                    타겟 선택(commPFindTarget)
                </ModalHeader>
                <ModalBody className="p-3">
                        <div className="p-3 bg-light">
                            <h5 className="mb-0 fw-bold">지역</h5>
                        </div>
                        <div className="p-3">
                            <CpmCommCodeRadio { ...areaOpt} />
                        </div>
                        <div className="p-3 bg-light">
                            <h5 className="mb-0 fw-bold">타겟</h5>
                        </div>
                        <div className="p-3">
                            {tgCatgList?.map((tg, idx) =>
                                <div key={`gr-${tg.type}-${idx}`} >
                                    <h6 className="pt-3" >
                                        {tg.lable}
                                    </h6>
                                    <div className="p-3">
                                        <div className="d-flex row-cols-lg-6 row-cols-sm-3  row-cols-auto  align-content-end flex-wrap">
                                            {tgDataList?.map((el, idx2 ) =>
                                                (tg.type === el.type ) && (
                                                    <div className="ms-3 form-check" key ={`key-${el.tgId}-${idx2}`} >
                                                        <input className={`form-check-input ${el.type}`}
                                                               type="checkbox"
                                                               id={`ch-tg-${el.tgId}`}
                                                               value = {el.tgId}
                                                               data-repcolnm={el.repColNm}
                                                               data-type = {el.type}
                                                               disabled ={false}
                                                               onChange={onChangeCheckTarget}
                                                               checked={ (el.chkYn ==="Y") ? true : false }
                                                        />
                                                        <label className="form-check-label" htmlFor={`ch-tg-${el.tgId}`}>{el.tgNm}</label>
                                                    </div>
                                               )
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                <div className="hstack gap-2 justify-content-center pt-3">
                    <Button color="dark" onClick={onClick_BtnSelect}> 확인 </Button>
                    <Button color="primary" onClick={() => handleModal( false )}> 취소 </Button>
                </div>
            </ModalBody>
           </Modal>
        </>
    )
}

export default CpmcommPFindTarget;
